export const CREATE = 'CREATE';
export const UPDATE = "UPDATE";
export const DELETE = "DELETE";
export const FETCH_ALL = "FETCH_ALL";
export const START_LOADING = "START_LOADING";
export const END_LOADING = "END_LOADING";
export const PAGE_ERROR = "PAGE_ERROR"

export const AUTH = 'AUTH';
export const LOGOUT = "LOGOUT"